import React from 'react';
import Button from '@atlaskit/button';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import InfoIcon from '@atlaskit/icon/glyph/info';
import './inline-message.scss';

interface inlineMessageProps {
  dismissMessage: () => void;
  headerText: string;
  labelText: string;
  buttonText: string;
}

export const InlineMessage = ({ dismissMessage, headerText, labelText, buttonText }: inlineMessageProps) => {
  return (
    <div style={{ position: 'relative' }}>
      <span className="inline-header">
        <InfoIcon label="Info" />
        <strong>{headerText}</strong>
      </span>
      <br />
      <label>{labelText}</label>
      <br />
      <Button testId="pricing-details" style={{ paddingLeft: '0' }} appearance="link">
        {buttonText}
      </Button>
      <span className="inline-dismiss-icon" onClick={dismissMessage}>
        <CrossIcon label="Close" />
      </span>
    </div>
  );
};
